import { Component, OnInit, OnDestroy} from '@angular/core';
import { DatePipe } from '@angular/common';
import { ActivatedRoute, Router } from '@angular/router';
import { AuthService } from '@app/shared/services/guards/auth.service';
import { HhtApiService } from '@app/shared/services/hht-api.service';
import { PrintService } from '@shared/services/print.service';
import { Hub, Auth } from 'aws-amplify';
import { Subscription } from 'rxjs';
import { take } from 'rxjs/operators';
import { NgbModal, NgbModalRef, NgbModalOptions } from '@ng-bootstrap/ng-bootstrap';
import { InformationComponent } from '@shared/modals/information/information.component';
import { ToastrService } from 'ngx-toastr';
import { rejects } from 'assert';
import { SelectReadingCenterComponent } from '@app/shared/modals/select-reading-center/select-reading-center.component';
import { environment } from '@environments/environment';


@Component({
  selector: 'app-itinerary-list',
  templateUrl: './itinerary-list.component.html',
  styleUrls: ['./itinerary-list.component.scss']
})
export class ItineraryListComponent implements OnInit, OnDestroy {
  isLoading: boolean = true;

  // sort
  page=1;
  prevPage=1;
  defPage=1;
  public toggleSort: boolean = true;
  public isSortedAgain: string;
  public selectedSort: string;

  public defaultMonth: string = "";
  public defaultYear: string = "";

  p: number = 1;
  public searchText : string;

  itineraryArray = [];

  userAccountInfo = [];

  searchString = '';
  limit = 10;
  offset= 0;
  totalCount: number;
  tempStatusFilter: string = '';
  itineraryStatusFilter: string = '';
  isFilterToggled: boolean = false;

  monthParse = {
    "01":"January",
    "02":"February",
    "03":"March",
    "04":"April",
    "05":"May",
    "06":"June",
    "07":"July",
    "08":"August",
    "09":"September",
    "10":"October",
    "11":"November",
    "12":"December"
  }

  monthOptions = [
    {
      month: 'January',
      value: '01'
    },
    {
      month: 'February',
      value: '02'
    },
    {
      month: 'March',
      value: '03'
    },
    {
      month: 'April',
      value: '04'
    },
    {
      month: 'May',
      value: '05'
    },
    {
      month: 'June',
      value: '06'
    },
    {
      month: 'July',
      value: '07'
    },
    {
      month: 'August',
      value: '08'
    },
    {
      month: 'September',
      value: '09'
    },
    {
      month: 'October',
      value: '10'
    },
    {
      month: 'November',
      value: '11'
    },
    {
      month: 'December',
      value: '12'
    }
  ]
  convertMonth:number;
  selectedMonth:string;
  yearOptions = [];
  selectedYear:string;
  userEmail:string;
  userName:string;

  cognitoUserName:string;
  Password0: string = '';
  selectedDevice: string = '';
  selectedMRFF: number = 1; // defau;t value of MRFF
  selectedConsumption: number = 1; //default value of Consumption


  assignToRoverFlag: boolean = false;
  isMultipleSelected: boolean = false;
  uploadToCISFlag: boolean = false;
  uploadToCISIsLoading: boolean = false;
  selectAllFlag: boolean = false;
  assignToRoverList: Array<any> = [];
  deviceCodeList: Array<any> = [];
  deviceCode$: Subscription;
  assignToRover$: Subscription;
  assignToRoverModal: NgbModalRef;
  previewOfItinerary$: Subscription;
  itineraryPreviewFlag: boolean = false;
  itineraryPreviewData: any;
  lotsDisplayData: Array<any> = [];
  lotsPage: number = 1;
  lotsCollectionSize: number = 0;
  itineraryPreviewIsLoading: boolean = false;
  uploadToCISItineraries: Array<any> = [];
  isUploadToCISButtonDisabled: boolean = true;

  sortKey: string = '';
  sortOrder: string = '';

  constructor(private router: Router, 
    private route: ActivatedRoute,
    private hhtApiService: HhtApiService,
    public authService: AuthService,
    private modal: NgbModal,
    public datePipe: DatePipe,
    private printService: PrintService,
    private toastr: ToastrService
    ) {
     }
    

  ngOnInit() {

    //async function onSignOutClick() {
    //  await Auth.signOut()
    //      .then(data => console.log(data))
    //      .catch(err => console.log(err));
    //  console.log(Auth.signOut({global:true}));
    //}
    //onSignOutClick()

    //async function signOut() {
    //  try{
    //    console.log('will signout')
    //    await Auth.signOut({ global: true })
    //  } catch (error){
    //    console.log('error signing out: ', error);
    //  }
    //}
    //signOut() 
    // console.log('-----')
    

    
    //sessionStorage.getItem('token')
    


    
    
    
    this.authService.isVerified().subscribe(data => {
      this.userEmail = String(data['username']).replace(environment.adPrefix, '');
      this.authService.assignCurrentUser(this.userEmail);
      var d = new Date();
      var currentMonth = d.getMonth();
      this.convertMonth = (currentMonth + 1);
      var month_ = "";
      if (this.convertMonth.toString().length == 1){
        month_ = "0" + this.convertMonth.toString();
      }
      else {
        month_ = this.convertMonth.toString()
      }
 


      this.selectedMonth =  month_;
      var currentYear = d.getFullYear();
      var startYear = currentYear - 10;
      for(let i=0; i<11; i++){
        let yearOption = startYear + i;
        this.yearOptions.push(yearOption)
      }

      this.selectedYear = currentYear.toString();

      this.hhtApiService.getReaderCodesbyEmail(this.userEmail).subscribe((res: any[])=>{
        const readingCenterCode = res['body']['results'][0]['readingCenterCode'].split('|');
        const defaultReadingCenterCode = res['body']['results'][0]['defaultReadingCenterCode'];
        if (readingCenterCode.length > 1 && !defaultReadingCenterCode) {
          const config: NgbModalOptions = {
            backdrop: 'static',
            windowClass: 'min-height-474',
            keyboard: false
          };
          const modalRef = this.modal.open(SelectReadingCenterComponent, config);
          modalRef.componentInstance.readingCenters = readingCenterCode;
          modalRef.componentInstance.email = this.userEmail;
          modalRef.componentInstance.afterSaving = () => {
            this.hhtApiService.getAllItineraries(this.searchString, this.limit, this.offset, this.selectedYear, this.selectedMonth, this.userEmail, this.itineraryStatusFilter, this.sortKey, this.sortOrder).subscribe((res: any[])=>{    
              this.itineraryArray = res['body']['itineraries'];
              this.totalCount = res['body']['details'][0]['total_count'];
              this.itineraryArray.forEach(item => {
                item.checked = this.assignToRoverList.some(list => list.itineraryNumber == item.itineraryNumber)
              });
              // console.log('totalCount',this.totalCount)
              // console.log('itineraryArray',this.itineraryArray)
              this.isLoading = false;
            });
          };
        } else {
          this.hhtApiService.getAllItineraries(this.searchString, this.limit, this.offset, this.selectedYear, this.selectedMonth, this.userEmail, this.itineraryStatusFilter, this.sortKey, this.sortOrder).subscribe((res: any[])=>{    
            this.itineraryArray = res['body']['itineraries'];
            this.totalCount = res['body']['details'][0]['total_count'];
            this.itineraryArray.forEach(item => {
              item.checked = this.assignToRoverList.some(list => list.itineraryNumber == item.itineraryNumber)
            });
            // console.log('totalCount',this.totalCount)
            // console.log('itineraryArray',this.itineraryArray)
            this.isLoading = false;
          });
        }
      });
    
      
      
      // console.log(Auth.currentUserInfo());
      this.authService.currentSession().subscribe(data => {
        
        //console.log('TOKEN-->',data.getIdToken().getJwtToken())
        this.userName = String(data.getIdToken().payload['cognito:username']).replace(environment.adPrefix, '');
        //-------
        
        this.hhtApiService.getUserAccountInfo(this.userName).subscribe((res: any[])=>{  
          // console.log(res['body']['UserInfo'])
          this.userAccountInfo = res['body']['UserInfo']
          let currentUser = this.authService.getCurrentUser();
          // console.log(currentUser);
          
          if(this.userAccountInfo.length > 0){       
            // console.log('Password Expiration Date:' + res['body']['UserInfo'][0]['expirationDate'])
            const d = new Date();
            let year = d.getFullYear();
            let month = d.getMonth() + 1;
            let day = d.getDate();
            // console.log(year + '-' + month + '-' + day)

            if (new Date(res['body']['UserInfo'][0]['expirationDate']) >= d) {

            }
            else {
              if(!currentUser.isAD){ //temporary workaround so that AD user won't redirect to change password. Need more discussion on this.
                this.router.navigate(['hht/change-password', {mustChangePass: true}], 
                { 
                });
              }
            }
            
          }
          else {
            console.log('Credential does not exist in db')
            if(!currentUser.isAD){ //temporary workaround so that AD user won't redirect to change password. Need more discussion on this.
              this.router.navigate(['hht/change-password', {mustChangePass: true}], 
              { 
              });
            }
            
          }
        })
      });

     
    });

    

    
  }

  onKeyupEnterSearch() {
    if(typeof this.searchText !== "undefined" && this.searchString !== this.searchText){
      this.resetFlags();
      this.isLoading = true;
      this.searchText = this.searchText.trim();
      this.searchString = this.searchText;
      this.itineraryArray = [];
      this.totalCount = 0;
      console.log('test onKeyupEnterSearch')
      this.hhtApiService.getAllItineraries(this.searchString, this.limit, this.offset, this.selectedYear, this.selectedMonth, this.userEmail, this.itineraryStatusFilter, this.sortKey, this.sortOrder).subscribe((res: any[])=>{      
        if(typeof res['body']['itineraries'] === "object"){
          this.itineraryArray = res['body']['itineraries'];
          this.totalCount = res['body']['details'].length>0 ? res['body']['details'][0]['total_count']: 0;
        }
        this.isLoading = false;        
      })
    }
  }

  ngOnDestroy(): void {
    if(!!this.deviceCode$){
      this.deviceCode$.unsubscribe();
    }
    if(!!this.assignToRover$){
      this.assignToRover$.unsubscribe();
    }
    if(!!this.previewOfItinerary$){
      this.previewOfItinerary$.unsubscribe();
    }
  }

  monthChanged(){
    this.isLoading = true;
    this.resetFlags();
    this.hhtApiService.getAllItineraries(this.searchString, this.limit, this.offset, this.selectedYear, this.selectedMonth, this.userEmail, this.itineraryStatusFilter, this.sortKey, this.sortOrder).subscribe((res: any[])=>{    
      // console.log(res['body']) 
      this.itineraryArray = res['body']['itineraries'];
      this.totalCount = res['body']['details'][0]['total_count'];
      // console.log(this.totalCount)
      // console.log(this.itineraryArray)
      this.isLoading = false;
    }) 
  }

  yearChanged(){
    this.isLoading = true;
    this.resetFlags();
    this.hhtApiService.getAllItineraries(this.searchString, this.limit, this.offset, this.selectedYear, this.selectedMonth, this.userEmail, this.itineraryStatusFilter, this.sortKey, this.sortOrder).subscribe((res: any[])=>{    
      // console.log(res['body']) 
      this.itineraryArray = res['body']['itineraries'];
      this.totalCount = res['body']['details'][0]['total_count'];
      // console.log(this.totalCount)
      console.log(this.itineraryArray)
      this.isLoading = false;
    }) 
  }

  onIteneraryRowClick(item) {
    this.router.navigate(['hht/itinerary-list/selected-itinerary'], 
    { 
      //relativeTo: this.route,
      queryParams: {
      'id': item.itineraryNumber,
      'readings': item.readings,
      'deviceCode':item.device_code,
      'readerCode':item.reader_code,
      'month':item.last_update_date.substring(0, 2),
      //'month':item.received_Month,
      'year':item.received_Year,
      'completionPercent': item.completionPercent,
      'email': this.authService.getCurrentUser().email,
      'accountType': this.authService.getCurrentUser().accountType
      },
      skipLocationChange: true //workaround so that the queryparams won't display in browser URL (security purpose)
    });
  }

  onSort(param: string) {
    let currentIdx = (this.defPage - 1) * this.limit
    let currentList = this.itineraryArray.slice(currentIdx, currentIdx + this.limit)



    if (this.prevPage !== this.page){
      this.isSortedAgain = ''
      this.prevPage = this.page
      this.toggleSort = true;
    }
    
    if (param === this.isSortedAgain) {
      this.isSortedAgain = param

      if (this.selectedSort === 'asc'){
        this.selectedSort = 'desc'
        this.toggleSort = !this.toggleSort
      } else if (this.selectedSort === 'desc'){
        this.selectedSort = ''
        this.toggleSort = !this.toggleSort
      } else {
        this.selectedSort = 'asc'
      }
    } else {
      this.isSortedAgain = param
      this.selectedSort = 'asc'
      this.toggleSort = true
    }

    
    if (this.selectedSort === 'asc' || this.selectedSort === 'desc'){
      if (this.toggleSort) {
        currentList.sort((a: any, b: any) => {          
          let textA = a[param] === null ? null : a[param].toString().toUpperCase();
          let textB = b[param] === null ? null : b[param].toString().toUpperCase();
          if (textA < textB) { return -1; }
          if (textA > textB) { return 1; }
          if (textA === null) { return 1; }
          if (textB === null) { return -1; }
          return 0;
        })
      } else {
        currentList.sort((a: any, b: any) => { 
          let textA = a[param] === null ? null : a[param].toString().toUpperCase();
          let textB = b[param] === null ? null : b[param].toString().toUpperCase();
          if (textA < textB) { return 1; }
          if (textA > textB) { return -1; }
          return 0;
        })
      }    
      Array.prototype.splice.apply(this.itineraryArray, [currentIdx, currentList.length].concat(currentList));
    }
  }

  onPageChange(event){
    this.prevPage = this.page;
    this.page = event;
    this.selectedSort = '';
    this.offset = (event - 1) * this.limit;
    this.isLoading = true;
    this.selectAllFlag = false;
    // this.assignToRoverFlag = false;
    // this.uploadToCISFlag = false;
    // this.itineraryPreviewFlag = false;
    this.hhtApiService.getAllItineraries(this.searchString, this.limit, this.offset, this.selectedYear, this.selectedMonth, this.userEmail, this.itineraryStatusFilter, this.sortKey, this.sortOrder).subscribe((res: any[])=>{      
      this.itineraryArray= res['body']['itineraries'];
      this.itineraryArray.forEach(item => {
        item.checked = this.assignToRoverList.some(list => list.itineraryNumber == item.itineraryNumber)
      });
      this.selectAllFlag = this.isCheckedAll();
      this.isLoading = false;
    }) 
  }
  
  omit_special_char(event)
  {   
    var k;  
    k = event.charCode;  //         k = event.keyCode;  (Both can be used)
    return((k > 64 && k < 91) || (k > 96 && k < 123) || k == 8 || k == 32 || (k >= 48 && k <= 57)); 
  }

  assignToRoverFlagFn(){
    //let arrayTest = this.itineraryArray.filter(data => { return !!data.checked });
    for(let item of this.itineraryArray){
      if(!!item.checked && !this.assignToRoverList.some(list => list.itineraryNumber == item.itineraryNumber)){
        item.imageHIGHLOW_0Consumption_prev = item.imageHIGHLOW_0Consumption; //added this property for assignToRoverList to remember the original imageHIGHLOW_0Consumption value in case user cancels assigning a rover
        item.imageMRFF_prev = item.imageMRFF; //added this property for assignToRoverList to remember the original imageHIGHLOW_0Consumption value in case user cancels assigning a rover
        this.assignToRoverList.push(item);
      }else if(!item.checked && this.assignToRoverList.some(list => list.itineraryNumber == item.itineraryNumber)){
        this.assignToRoverList = this.assignToRoverList.filter(data => {return data.itineraryNumber != item.itineraryNumber});
      }
    }
    this.isMultipleSelected = this.assignToRoverList.length > 1;
    if(!!this.isMultipleSelected){
      this.itineraryPreviewData = null;
      this.lotsDisplayData = [];
    }else{
      if(this.assignToRoverList.length == 1 && ['RECEIVED', 'SEPARATED HHT', 'HANDLED', 'PARTIALLY UPLOADED'].includes(String(this.assignToRoverList[0].status))){
        this.showItineraryPreview(this.assignToRoverList[0]);
      }else{
        this.lotsPage = 1;
      }
    }
    this.itineraryPreviewFlag = this.assignToRoverList.length == 1 && 
                                ((['RECEIVED', 'SEPARATED HHT', 'PARTIALLY UPLOADED'].includes(String(this.assignToRoverList[0].status).toUpperCase())) ||
                                 ('HANDLED' == String(this.assignToRoverList[0].status).toUpperCase() && !Number.isNaN(parseInt(this.assignToRoverList[0].completionPercent)) &&
                                 parseInt(this.assignToRoverList[0].completionPercent) != 100)
                                );
    let test = new Set(this.assignToRoverList.map(selected => String(selected.status).toUpperCase()));
    let percent = this.assignToRoverList.map(selected => selected.completionPercent)
    let isAllCompleted = percent.every(item => item === '100.00');
    // console.log('isAllCompleted:',isAllCompleted)
    this.assignToRoverFlag = (!!test.has('RECEIVED') || ((!!test.has('HANDLED') || !!test.has('PARTIALLY UPLOADED')) && isAllCompleted == false )) && test.size == 1; //selected itineraries must only be with status RECEIVED, HANDLED or PARTIALLY UPLOADED to enable assign to rover
    this.uploadToCISFlag = !!test.has('HANDLED') && test.size == 1; //selected itineraries must only be with status HANDLED to enable upload to cis
  
  
  }

  assignToRoverListFn(modalContent, option?){
    
    this.deviceCodeList = [];
    // this.assignToRoverList = this.itineraryArray.filter(itineraries =>{
    //   let arrayTest = this.itineraryArray.filter(data => { return !!data.checked });
    //   let percent = arrayTest.map(selected => selected.completionPercent)
    //   let isAllCompleted = percent.every(item => item === '100.00');

    //   return (
    //         !!itineraries.checked && 
    //                               (  String(itineraries.status).toUpperCase() == 'RECEIVED' ||
    //                                 (String(itineraries.status).toUpperCase() == 'HANDLED' && isAllCompleted == false ) ||
    //                                 String(itineraries.status).toUpperCase() == 'PARTIALLY UPLOADED'
    //                               )
    //         );
    // });

    //check if route_image_capturing is deactivated. If so, then set imageHIGHLOW_0Consumption and imageMRFF to zero.
    this.assignToRoverList = this.assignToRoverList.map(itn =>{
      if(itn.route_image_capturing == 0){
        itn.imageHIGHLOW_0Consumption = 0;
        itn.imageMRFF = 0;
      }
      return itn;
    });
    
    this.deviceCode$ = this.hhtApiService.getDeviceCodes('AVAILABLE')
        .pipe(take(1))
        .subscribe(result =>{
          this.deviceCodeList = result['body']['results'];
          // console.log(this.deviceCodeList)
          
        },
        error =>{
          alert('Error fetching Device Codes: \n'+ error)
        })
   
    this.assignToRoverModal = this.modal.open(modalContent, option);
    
  }

  assignToRover(){
    //validations
    //check if there are duplicate device codes being used
    // const uniqueValues = new Set(this.assignToRoverList.map(roverList => roverList.deviceCode));
    // if(uniqueValues.size < this.assignToRoverList.length){
    //   const modalRef = this.modal.open(InformationComponent);
    //   modalRef.componentInstance.header = 'Information';
    //   modalRef.componentInstance.information = 'Itineraries must have its own unique device code.'
    //   modalRef.componentInstance.positiveButton = 'Close';
    //   return;
    // }
    
    //assigning proper
   
    let itnAssigned: Array<any> = [];
    // console.log(this.assignToRoverList);
    for(let itineraries of this.assignToRoverList){
      itnAssigned.push({
        itineraryCode: itineraries.itineraryNumber,
        deviceCode: itineraries.deviceCode,
        imageHIGHLOW_0Consumption: itineraries.imageHIGHLOW_0Consumption,
        imageMRFF: itineraries.imageMRFF,
        email: this.authService.getCurrentUser().email,
        year: this.selectedYear,
        month: this.selectedMonth
      })
    }
    
    const requestPayload = { data: itnAssigned };
    // console.log('payload', requestPayload);
    this.modal.dismissAll();
    this.isLoading = true;
    this.hhtApiService.assignToRover(requestPayload)
                      .pipe(take(1))
                      .subscribe(result =>{
                        // const modalRef = this.modal.open(InformationComponent);
                        // modalRef.componentInstance.header = 'Information';
                        // modalRef.componentInstance.information = result['body']['results'];
                        // modalRef.componentInstance.positiveButton = 'Close';
                        // this.assignToRoverModal.dismiss();
                        this.toastr.success('Your itinerary have been assigned successfully!', 'Updated Itineraries', {closeButton: true, progressBar:true, timeOut: 10000, extendedTimeOut: 10000 })
                        this.resetFlags();
                        //fetch al itineraries again, but consider making one seperate function for getting itineraries as its always being used in this component (best practice!)
                        this.hhtApiService.getAllItineraries(this.searchString, this.limit, this.offset, this.selectedYear, this.selectedMonth, this.userEmail, this.itineraryStatusFilter, this.sortKey, this.sortOrder).subscribe((res: any[])=>{    
                          this.itineraryArray = res['body']['itineraries'];
                          this.totalCount = res['body']['details'][0]['total_count'];
                          this.itineraryArray.forEach(item => {
                            item.checked = this.assignToRoverList.some(list => list.itineraryNumber == item.itineraryNumber)
                          });
                          // console.log('totalCount',this.totalCount)
                          // console.log('itineraryArray',this.itineraryArray)
                          this.isLoading = false;
                        }) 
                      },
                      error =>{
                        alert('Error assigning to rover: \n'+ error);
                      })
  }

  uploadtoCISFn(){
    this.uploadToCISIsLoading = true;
    let requestBody = {
      data: [],
      email: this.authService.getCurrentUser().email,
      year: this.selectedYear,
      month: this.selectedMonth
    }
    const itineraryCodes = [];
    for(let itinerary of this.uploadToCISItineraries){
      if(!!itinerary.checked){
        requestBody.data.push({
          itineraryCode: itinerary.itineraryNumber,
          status: itinerary.cis_status
        })
        itineraryCodes.push(itinerary.itineraryNumber);
      }
    }
    this.hhtApiService.uploadToCIS(requestBody)
                      .pipe(take(1))
                      .subscribe(uploadResult =>{
                        this.toastr.success('Your Itineraries have been uploaded to CIS successfully!', 'Uploaded to CIS', {closeButton: true, progressBar:true, timeOut: 10000, extendedTimeOut: 10000 });
                        this.uploadToCISIsLoading = false;
                        this.resetFlags();
                        this.modal.dismissAll();
                        this.isLoading = true;
                        const result = uploadResult['body'];
                        const alo047fileName = result['ALO047_filename'];
                        const alo050fileName = result['ALO050_filename'];
                        console.log("47",alo047fileName)
                        console.log("50",alo050fileName)
                        // ALO047 upload json file
                        const alo047Data = result['ALO047'];
                        // TODO once the endpoint is finalized
                        // TODO: change the `result` variable to `alo047Data` in alo047JsonFile
                        const alo047JsonFile = this.convertToJsonFile(result, "ALO047.json");
                        // TODO: change the API with the finalized endpoint
                        // this.hhtApiService.validateUploadToCISFile(alo047JsonFile).subscribe((res: any[])=>{
                        let requestBodyAlo047 = {
                          fileType: "alo047",
                          fileName: alo047fileName
                        }
                        this.hhtApiService.validateUploadToCISFile(requestBodyAlo047).subscribe((res: any[])=>{
                          console.log("alo047 response");
                          console.log(res['body']);
                        });
                        
                        // ALO050 upload json file
                        const alo050Data = result['ALO050'];
                        // TODO once the endpoint is finalized
                        // TODO: change the `result` variable to `alo050Data` in alo050JsonFile
                        const alo050JsonFile = this.convertToJsonFile(result, "ALO050.json");
                        // TODO: change the API with the finalized endpoint
                        // this.hhtApiService.validateUploadToCISFile(alo050JsonFile).subscribe((res: any[])=>{
                        let requestBodyAlo050 = {
                          fileType: "alo050",
                          fileName: alo050fileName
                        }
                        this.hhtApiService.validateUploadToCISFile(requestBodyAlo050).subscribe((res: any[])=>{
                          console.log("alo050 response");
                          console.log(res['body']);
                        });
                        //fetch al itineraries again, but consider making one seperate function for getting itineraries as its always being used in this component (best practice!)
                        this.hhtApiService.getAllItineraries(this.searchString, this.limit, this.offset, this.selectedYear, this.selectedMonth, this.userEmail, this.itineraryStatusFilter, this.sortKey, this.sortOrder).subscribe((res: any[])=>{    
                            this.itineraryArray = res['body']['itineraries'];
                            this.totalCount = res['body']['details'][0]['total_count'];
                            this.itineraryArray.forEach(item => {
                              item.checked = this.assignToRoverList.some(list => list.itineraryNumber == item.itineraryNumber)
                            });
                            // console.log('totalCount',this.totalCount)
                            // console.log('itineraryArray',this.itineraryArray)
                            this.isLoading = false;
                        });
                      },
                      error =>{
                        this.modal.dismissAll();
                        this.toastr.success(error['message'], 'Uploaded to CIS', {closeButton: true, progressBar:true, timeOut: 10000, extendedTimeOut: 10000 });
                        this.uploadToCISIsLoading = false;
                      });
  }

  selectAllItineraries() { //Note that select all does not mean select all itineraries on the database. Only the ones sent by the API will be selected (max 10 rows)
    this.selectAllFlag = !this.selectAllFlag;
    this.itineraryArray.forEach(data =>{
      if(!!this.selectAllFlag){
        this.assignToRoverList.push(data);
      }else{
        this.assignToRoverList = this.assignToRoverList.filter(list => { return data.itineraryNumber != list.itineraryNumber });
      }
      data.checked = this.selectAllFlag;
    });
    console.log('selectall',this.assignToRoverList)
    // this.itineraryArray.forEach(data => { return data.checked = this.selectAllFlag });
    this.assignToRoverFlagFn();
  }

  isCheckedAll(): boolean{
    return this.itineraryArray.every(data => data.checked);
  }

  assignToRoverFormValidation(): boolean{
    // console.log('validate', this.assignToRoverList);
    // console.log('tufals', this.assignToRoverList.every(data => !!data.deviceCode));
    return this.assignToRoverList.every(data => !!data.deviceCode);
  }

  getSingleCheckedItinerary() {
    const checkedItineraries = this.itineraryArray.filter(data => { return data.checked });
    if (checkedItineraries.length === 1) {
      return checkedItineraries[0];
    } else {
      return null;
    }
  }

  getSingleCheckedReceivedItinerary() {
    const checkedItinerary = this.getSingleCheckedItinerary();
    if (checkedItinerary && checkedItinerary.status === "RECEIVED") {
      return checkedItinerary.itineraryNumber;
    } else {
      return null;
    }
  }

  assignToRoverMultiple(){
    this.assignToRoverList.forEach((value, key) => {
      this.assignToRoverList[key].deviceCode = this.selectedDevice;
   });
  }
  
  removeAssignToRoverMultiple(){
    this.selectedDevice = '';
    this.assignToRoverList.forEach((value, key) => {
      this.assignToRoverList[key].deviceCode = ''; //empty the inputted device code after cancelling
      //revert the default values of imageMRFF and imageHIGHLOW_0Consumption to its original (based from itineraries_v2)
      this.assignToRoverList[key].imageMRFF = this.assignToRoverList[key].imageMRFF_prev;
      this.assignToRoverList[key].imageHIGHLOW_0Consumption = this.assignToRoverList[key].imageHIGHLOW_0Consumption_prev;
   });
  }

  confirmModal(modalContent){
    this.modal.dismissAll();
    this.modal.open(modalContent);
  }

  showItineraryPreview(itineraryData){

    let params = { itineraryCode: itineraryData.itineraryNumber, email: this.userEmail , year: this.selectedYear, month: this.selectedMonth};
    this.itineraryPreviewIsLoading = true;
    this.previewOfItinerary$ = this.hhtApiService.previewOfItinerary(params)
                                                 .pipe(take(1))
                                                 .subscribe((itinerary: any) =>{
      const result = itinerary['body']['results'];
      if(result.length == 1){
        this.itineraryPreviewData = result[0];
        this.lotsCollectionSize = this.itineraryPreviewData['lots'].length;
        this.itineraryPreviewData['itineraryCode'] = itineraryData.itineraryNumber;
        this.previewPageChange();
      }
      this.itineraryPreviewIsLoading = false;
    },
    error =>{
      alert('Error in retrieving itinerary preview data.');
    })
  }

  previewPageChange(){
    this.lotsDisplayData = this.itineraryPreviewData['lots']
                .map((elements, index) => ({
                  test: index + 1, ...elements
                }))
                .slice((this.lotsPage - 1) * this.limit, (this.lotsPage -1) * this.limit + this.limit);
    // console.log(this.lotsDisplayData);
  }
  
  printPreviewItinerary(){
    this.printService.printPreviewOfItinerary(this.itineraryPreviewData);
  }

  onChangeFilter(){
    this.isLoading = true;
    this.resetFlags();
    this.itineraryStatusFilter = this.tempStatusFilter;
    this.hhtApiService.getAllItineraries(this.searchString, this.limit, this.offset, this.selectedYear, this.selectedMonth, this.userEmail, this.itineraryStatusFilter, this.sortKey, this.sortOrder).subscribe((res: any[])=>{    
      this.itineraryArray = res['body']['itineraries'];
      this.totalCount = res['body']['details'][0]['total_count'];
      // console.log(this.totalCount)
      // console.log(this.itineraryArray)
      this.isLoading = false;
    }) 
  }
  
  openUploadToCISModal(modalContent) {
    this.uploadToCISItineraries = this.assignToRoverList.filter((data) => data.checked).map((data) => ({ ...data, cis_status: Number(data.completionPercent) === 100 ? "TRANSMITTED" : null }));
    //this.uploadToCISItineraries = this.itineraryArray.filter((data) => data.checked).map((data) => ({ ...data, cis_status: Number(data.completionPercent) === 100 ? "TRANSMITTED" : null }));
    //this.isUploadToCISButtonDisabled = true;
    //this.isUploadToCISButtonDisabled = this.assignToRoverList.some((data) => !data.cis_status);
    this.isUploadToCISButtonDisabled = this.uploadToCISItineraries.some((data) => !data.cis_status);
    this.uploadToCISIsLoading = false;
    this.modal.open(modalContent, { size: 'lg' });
  }

  changeUploadToCISStatus() {
    //this.isUploadToCISButtonDisabled = this.assignToRoverList.some((data) => !data.cis_status);
    this.isUploadToCISButtonDisabled = this.uploadToCISItineraries.some((data) => !data.cis_status);
  }

  convertToJsonFile(data, filename) {
    const jsonFile = new File([JSON.stringify(data)], filename, { type: "application/json" });
    return jsonFile;
  }

  convertMstsToTextFile(data, filename) {
    const results = data['results'];
    const date = data['date'];
    const time = data['time'];
    const space = (count) => { return ' '.repeat(count); };
    const modifiedData = results.map((result) => {
      let textHeader = `                       MERALCO-CUSTOMER MANAGEMENT SYSTEM\n`;
      textHeader += `USER : ${this.userEmail}${space(26 - this.userEmail.length > 0 ? 26 - this.userEmail.length : 1)}METER SEAL REPORT              DATE :${this.datePipe.transform(date, 'MM/d/yyyy')}\n`;
      textHeader += `                                                                TIME :${time}\n\n`;
      textHeader += `             READING CENTER  : ${result['readingCenterCode']}        THEORETICAL RDG DATE: ${this.datePipe.transform(result['theoreticalReadDate'], 'M/d/yyyy') || ''}\n`;
      textHeader += `             ROUTE           : ${result['route']}          ACTUAL RDG DATE     : ${this.datePipe.transform(result['readDate'], 'M/d/yyyy') || ''}\n`;
      textHeader += `             CYCLE           : ${result['cycle']}          READER CODE         : ${result['readerCode']}\n`;
      textHeader += `             ITINERARY NUMBER: ${result['itineraryCode'].substr(result['itineraryCode'].length - 4)}        HHT CODE            : ${result['device_code']}\n\n`;
      textHeader += `-------------------------------------------------------------------------------\n`;
      textHeader += `        ITEM NO.  INSTALLED SEAL  REMOVED SEAL  METER NUMBER  LOT ID NO.\n`;
      textHeader += `-------------------------------------------------------------------------------\n`;
      let table = [];
      result['lots'].forEach(lot => {
        lot['meteringPoints'].forEach(meteringPoint => {
          meteringPoint['meters'].forEach(meter => {
            if (meter['meterSeal'].length > 0) {
              meter['meterSeal'].forEach(seal => {
                const getItemNoMiddle = (5 - String(seal['item_no']).length) / 2;
                const getLotIdNoMiddle = (8 - String(lot['lot_id_number']).length) / 2;
                const getRemovedMiddle = (12 - String(seal['removed']).length);
                table.splice(seal['item_no'], 0, `${space(9 + Math.ceil(getItemNoMiddle))}${seal['item_no']}${space(5 + Math.floor(getItemNoMiddle))}${seal['installed']}   ${seal['removed']}${space(Math.floor(getRemovedMiddle))} ${meter['meterNo']}${space(4 + Math.floor(getLotIdNoMiddle))}${lot['lot_id_number']}\n`);
              });
            }
          });
        });
      });
      if (table.length > 0) {
        return textHeader + table.join('');
      } else {
        return '';
      }
    });
    const textFile = new File([modifiedData.join('')], filename, { type: "text/plain" });
    return textFile;
  }

  isSortedBy(col: string) {
    if (this.sortKey === col && this.sortOrder) {
      return this.sortOrder;
    } else {
      return null;
    }
  }

  onSortFn(col) {
    switch(this.sortOrder){
      case 'asc':
        this.sortOrder = 'desc';
      break;
      case 'desc':
        this.sortOrder = '';
      break;
      case '':
        this.sortOrder = 'asc';
      break;
    }
    if (this.sortKey !== col) {
      this.sortOrder = 'asc';
    }
    this.sortKey = col;
    this.isLoading = true;
    this.hhtApiService.getAllItineraries(this.searchString, this.limit, this.offset, this.selectedYear, this.selectedMonth, this.userEmail, this.itineraryStatusFilter, this.sortKey, this.sortOrder).subscribe((res: any[])=>{    
      this.itineraryArray = res['body']['itineraries'];
      this.itineraryArray.forEach(item => {
        item.checked = this.assignToRoverList.some(list => list.itineraryNumber == item.itineraryNumber)
      });
      this.selectAllFlag = this.isCheckedAll();
      this.isLoading = false;
    }) 
  }

  resetFlags(){
    this.assignToRoverFlag = false;
    this.uploadToCISFlag = false;
    this.itineraryPreviewFlag = false
    this.selectAllFlag = false;
    this.itineraryPreviewData = null;
    this.assignToRoverList = [];
    this.uploadToCISItineraries = [];
  }

  cancelUploadToCISModal(){
    this.modal.dismissAll();
    this.toastr.success('Itineraries have not been uploaded to CIS. No changes were saved', 'Unsaved Changes', {closeButton: true, progressBar:true, timeOut: 10000, extendedTimeOut: 10000 });
  }

}
